import moment from 'moment';

export const dailyShift = [moment('00:00', 'HH:mm'), moment('00:59', 'HH:mm')];
export const morningShift = [moment('06:00', 'HH:mm'), moment('17:59', 'HH:mm')];
export const nightShift = [moment('18:00', 'HH:mm'), moment('05:59', 'HH:mm')];
export const defaultRange = [moment('00:00', 'HH:mm'), moment('00:59', 'HH:mm')];
